/*
 * VinylToast – favourites ("Favoritter").
 * - Heart on product cards and on the product page; heart with count in the header.
 * - The list lives in this browser only (localStorage "vt-favs"): no login, no cookies.
 * - Each add/remove is counted anonymously in the VinylToast admin app (no visitor id).
 * - The page /pages/favourites (element #vt-favorites) shows the saved records.
 */
(function () {
  if (window.vtFavorites) return;

  var KEY = 'vt-favs';
  var ENDPOINT = 'https://agile-roadrunner-80.eu-west-1.convex.site/fav';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var da = (document.documentElement.lang || '').toLowerCase().indexOf('da') === 0;
  var T = da
    ? {
        add: 'Tilføj til favoritter',
        remove: 'Fjern fra favoritter',
        save: 'Gem som favorit',
        saved: 'Gemt i favoritter',
        title: 'Favoritter',
        empty: 'Du har ingen favoritter endnu. Tryk på hjertet ved en plade for at gemme den her.',
        browse: 'Se alle plader',
        sold: 'Solgt',
        gone: 'Ikke længere i shoppen',
        removeShort: 'Fjern',
        note: 'Dine favoritter gemmes kun i denne browser.',
      }
    : {
        add: 'Add to favourites',
        remove: 'Remove from favourites',
        save: 'Save as favourite',
        saved: 'Saved in favourites',
        title: 'Favourites',
        empty: 'You have no favourites yet. Tap the heart on a record to save it here.',
        browse: 'Browse all records',
        sold: 'Sold',
        gone: 'No longer in the shop',
        removeShort: 'Remove',
        note: 'Your favourites are saved in this browser only.',
      };

  var HEART =
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.2-1.1C6.1 15 3 12.2 3 8.7 3 5.9 5.2 3.8 7.9 3.8c1.6 0 3.1.7 4.1 1.9 1-1.2 2.5-1.9 4.1-1.9 2.7 0 4.9 2.1 4.9 4.9 0 3.5-3.1 6.3-7.8 10.5L12 20.3z" fill="var(--vt-fav-fill, none)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  // ---------- storage ----------
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && x.id; }) : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200)));
    } catch (e) {}
  }
  function has(id) {
    id = String(id);
    return read().some(function (x) { return String(x.id) === id; });
  }
  function track(id, action) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ p: Number(id), a: action, l: da ? 'da' : 'en' }),
      }).catch(function () {});
    } catch (e) {}
  }
  function toggle(id, handle) {
    id = String(id);
    var list = read();
    var i = list.findIndex(function (x) { return String(x.id) === id; });
    if (i >= 0) {
      list.splice(i, 1);
      track(id, 'remove');
    } else {
      list.unshift({ id: id, h: handle || '', t: Date.now() });
      track(id, 'add');
    }
    write(list);
    refresh();
    return i < 0;
  }

  // ---------- UI ----------
  function setButton(btn, on) {
    btn.classList.toggle('is-fav', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? T.remove : T.add;
    btn.setAttribute('aria-label', label);
    btn.title = label;
    var text = btn.querySelector('.vt-fav-text');
    var want = on ? T.saved : T.save;
    if (text && text.textContent !== want) text.textContent = want;
  }

  function makeButton(id, handle, cls, withText) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vt-fav ' + cls;
    b.dataset.vtFavId = id;
    b.innerHTML = HEART + (withText ? '<span class="vt-fav-text"></span>' : '');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var on = toggle(id, handle);
      b.classList.remove('vt-pop');
      if (on) {
        void b.offsetWidth;
        b.classList.add('vt-pop');
      }
    });
    setButton(b, has(id));
    return b;
  }

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function decorateCards(scope) {
    (scope || document).querySelectorAll('product-card[data-product-id]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id || card.querySelector(':scope > .vt-fav--card')) return;
      var link = card.querySelector('a.product-card__link, a[href*="/products/"]');
      var handle = handleFromHref(link && link.getAttribute('href'));
      card.classList.add('vt-fav-host');
      card.appendChild(makeButton(id, handle, 'vt-fav--card', false));
    });
  }

  function decorateProductPage() {
    var handle = handleFromHref(location.pathname);
    if (!handle || document.querySelector('.vt-fav--buy')) return;
    var main = document.getElementById('MainContent') || document.body;
    var form = main.querySelector('product-form-component[data-product-id]');
    var id = form && form.getAttribute('data-product-id');
    if (!id) {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      id = meta && meta.id ? String(meta.id) : '';
    }
    if (!id) return;
    var btn = makeButton(id, handle, 'vt-fav--buy', false);
    var atc = form && form.querySelector('add-to-cart-component');
    var row = atc && atc.parentElement;
    if (row) {
      // Heart sits to the right of "Add to cart".
      row.classList.add('vt-buy-row');
      row.appendChild(btn);
      return;
    }
    var anchor = form || main.querySelector('h1');
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.className = 'vt-fav-page-wrap';
    wrap.appendChild(btn);
    anchor.insertAdjacentElement('afterend', wrap);
  }

  // "More from <artist>" (custom section on the product page): its cards only have a link,
  // so the product id is looked up once per handle and remembered for the visit.
  var idCache = {};
  try {
    idCache = JSON.parse(sessionStorage.getItem('vt-fav-ids') || '{}') || {};
  } catch (e) {}
  function idFor(handle) {
    if (idCache[handle]) return Promise.resolve(idCache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.id) return '';
        idCache[handle] = String(p.id);
        try {
          sessionStorage.setItem('vt-fav-ids', JSON.stringify(idCache));
        } catch (e) {}
        return idCache[handle];
      })
      .catch(function () { return ''; });
  }
  function decorateMoreCards() {
    document.querySelectorAll('.vt-more__grid > li').forEach(function (li) {
      if (li.dataset.vtFav) return;
      var a = li.querySelector('a.vt-more__card');
      var handle = handleFromHref(a && a.getAttribute('href'));
      if (!handle) return;
      li.dataset.vtFav = '1';
      idFor(handle).then(function (id) {
        if (!id || li.querySelector('.vt-fav--card')) return;
        li.classList.add('vt-fav-host');
        li.appendChild(makeButton(id, handle, 'vt-fav--card', false));
      });
    });
  }

  function decorateHeader() {
    document.querySelectorAll('header-actions').forEach(function (actions) {
      if (actions.querySelector(':scope > .vt-fav-header')) return;
      var a = document.createElement('a');
      a.href = root + 'pages/favourites';
      a.className = 'header-actions__action vt-fav-header';
      a.setAttribute('aria-label', T.title);
      a.title = T.title;
      a.innerHTML = HEART + '<span class="vt-fav-count" hidden></span>';
      var cart = actions.querySelector('[data-testid="cart-drawer-trigger"], a.action__cart');
      if (cart) actions.insertBefore(a, cart);
      else actions.appendChild(a);
    });
  }

  function refresh() {
    var n = read().length;
    document.querySelectorAll('.vt-fav-header').forEach(function (a) {
      var c = a.querySelector('.vt-fav-count');
      var label = n > 99 ? '99+' : String(n);
      if (c.textContent !== label) c.textContent = label;
      c.hidden = n === 0;
      a.classList.toggle('is-fav', n > 0);
    });
    document.querySelectorAll('button.vt-fav[data-vt-fav-id]').forEach(function (b) {
      setButton(b, has(b.dataset.vtFavId));
    });
  }

  // ---------- favourites page ----------
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    try {
      return new Intl.NumberFormat(da ? 'da-DK' : 'en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderPage() {
    var box = document.getElementById('vt-favorites');
    if (!box) return;
    var list = read();
    if (!list.length) {
      box.innerHTML =
        '<p class="vt-favs-empty">' + esc(T.empty) + '</p>' +
        '<p><a class="button" href="' + root + 'collections/vinyl">' + esc(T.browse) + '</a></p>';
      return;
    }
    box.innerHTML = '<ul class="vt-favs-grid" role="list"></ul><p class="vt-favs-note">' + esc(T.note) + '</p>';
    var ul = box.querySelector('ul');
    list.forEach(function (fav) {
      var li = document.createElement('li');
      li.className = 'vt-favs-item';
      li.dataset.vtFavItem = fav.id;
      ul.appendChild(li);
      var url = fav.h ? root + 'products/' + encodeURIComponent(fav.h) : '';
      var fill = function (p) {
        var img = p && p.featured_image ? p.featured_image : '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var sized = img ? img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=500' : '';
        li.innerHTML =
          (p ? '<a class="vt-favs-link" href="' + esc(url) + '">' : '<div class="vt-favs-link">') +
          '<span class="vt-favs-media">' +
          (sized ? '<img src="' + esc(sized) + '" alt="" loading="lazy">' : '') +
          (p && !p.available ? '<span class="vt-favs-badge">' + esc(T.sold) + '</span>' : '') +
          '</span>' +
          '<span class="vt-favs-title">' + esc(p ? p.title : T.gone) + '</span>' +
          (p ? '<span class="vt-favs-price">' + esc(money(p.price)) + '</span>' : '') +
          (p ? '</a>' : '</div>') +
          '<button type="button" class="vt-favs-remove">' + esc(T.removeShort) + '</button>';
        if (p && !p.available) li.classList.add('is-sold');
        li.querySelector('.vt-favs-remove').addEventListener('click', function () {
          toggle(fav.id, fav.h);
          li.remove();
          if (!read().length) renderPage();
        });
      };
      if (!fav.h) return fill(null);
      fetch(root + 'products/' + encodeURIComponent(fav.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(fill)
        .catch(function () { fill(null); });
    });
  }

  // ---------- styles ----------
  var css =
    '.vt-fav{display:inline-flex;align-items:center;justify-content:center;gap:.4em;cursor:pointer;color:inherit;background:none;border:0;padding:0;font:inherit;-webkit-tap-highlight-color:transparent}' +
    '.vt-fav.is-fav{--vt-fav-fill:#c9584c;color:#c9584c}' +
    '.vt-fav:focus-visible{outline:2px solid currentColor;outline-offset:2px}' +
    '.vt-fav-host{position:relative}' +
    '.vt-fav--card{position:absolute;top:8px;left:8px;z-index:5;width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.88);color:#111;box-shadow:0 1px 3px rgba(0,0,0,.15)}' +
    '.vt-fav--card.is-fav{color:#c9584c}' +
    '@media (hover:hover){.vt-fav--card{opacity:.85}.vt-fav--card:hover{opacity:1}}' +
    '.vt-fav-page-wrap{margin:12px 0}' +
    '.product-form-buttons .vt-buy-row{display:flex;align-items:stretch;gap:8px}' +
    '.product-form-buttons .vt-buy-row>add-to-cart-component{display:block;flex:1 1 auto;min-width:0}' +
    '.product-form-buttons .vt-buy-row>button.vt-fav--buy{flex:0 0 auto;width:var(--height-buy-buttons,48px);height:var(--height-buy-buttons,48px);padding:0;border:1px solid rgb(var(--color-foreground-rgb,0 0 0)/.25);border-radius:var(--style-border-radius-buttons-primary,0)}' +
    '.vt-fav--buy svg{width:22px;height:22px}' +
    '.product-form-buttons .vt-buy-row>button.vt-fav--buy:hover{border-color:currentColor}' +
    '.product-form-buttons .vt-buy-row>button.vt-fav--buy.is-fav{border-color:#c9584c}' +
    '.vt-fav-page-wrap .vt-fav--buy{width:48px;height:48px;border:1px solid rgb(var(--color-foreground-rgb,0 0 0)/.25)}' +
    '.vt-fav.vt-pop svg{animation:vtpop .35s ease}' +
    '@keyframes vtpop{40%{transform:scale(1.3)}}' +
    '@media (prefers-reduced-motion:reduce){.vt-fav.vt-pop svg{animation:none}}' +
    '.vt-fav-header{position:relative;display:inline-flex;align-items:center;justify-content:center;min-width:40px;min-height:44px;color:inherit}' +
    // Small screens: no room for account + favourites + cart next to the logo, so the account icon gives way.
    '@media (max-width:749px){header-actions:has(.vt-fav-header) .account-button{display:none}}' +
    '.vt-fav-header.is-fav{--vt-fav-fill:currentColor}' +
    '.vt-fav-count{position:absolute;top:4px;right:2px;min-width:18px;height:18px;padding:0 4px;border-radius:9px;background:#c9584c;color:#fff;font-size:11px;line-height:18px;text-align:center;font-weight:600}' +
    '.vt-fav-count[hidden]{display:none}' +
    '#vt-favorites .vt-favs-grid{list-style:none!important;margin:0!important;padding:0!important;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}' +
    '@media (min-width:750px){.vt-favs-grid{grid-template-columns:repeat(4,minmax(0,1fr))}}' +
    '#vt-favorites .vt-favs-item{margin:0!important;padding:0!important}' +
    '.vt-favs-item{display:flex;flex-direction:column;gap:6px}' +
    '.vt-favs-link{display:flex;flex-direction:column;gap:4px;color:inherit;text-decoration:none}' +
    '.vt-favs-media{position:relative;display:block;aspect-ratio:1/1;overflow:hidden;background:rgba(0,0,0,.05)}' +
    '.vt-favs-media img{width:100%;height:100%;object-fit:cover;transform:scale(1.25)}' +
    '.vt-favs-item.is-sold .vt-favs-media img{opacity:.5}' +
    '.vt-favs-badge{position:absolute;top:8px;right:8px;background:#c9584c;color:#000;font-size:11px;font-weight:700;text-transform:uppercase;padding:2px 6px;border-radius:2px}' +
    '.vt-favs-title{font-size:.95em;line-height:1.3}' +
    '.vt-favs-price{font-weight:500}' +
    '.vt-favs-remove{align-self:flex-start;background:none;border:0;padding:0;color:inherit;opacity:.6;text-decoration:underline;cursor:pointer;font:inherit;font-size:.85em}' +
    '.vt-favs-remove:hover{opacity:1}' +
    '.vt-favs-note{margin-top:24px;font-size:.85em;opacity:.6}' +
    '.vt-favs-empty{margin-bottom:16px}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // ---------- boot ----------
  function boot() {
    decorateHeader();
    decorateCards();
    decorateMoreCards();
    decorateProductPage();
    renderPage();
    refresh();
    // Filters, infinite scroll and the header re-render parts of the page: re-attach hearts.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        decorateHeader();
        decorateCards();
        decorateMoreCards();
        decorateProductPage();
        refresh();
      });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) refresh();
    });
  }

  window.vtFavorites = { read: read, toggle: toggle };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
